import { render, staticRenderFns } from "./renderCategory.vue?vue&type=template&id=6b7b3d1e&scoped=true"
import script from "./renderCategory.vue?vue&type=script&lang=js"
export * from "./renderCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7b3d1e",
  null
  
)

export default component.exports